import { Component, Inject, Vue } from 'vue-property-decorator';
import { convertDateToCustomFormat } from '@/util/date-util';
import { UserPlan } from '@/shared/model/account.model';
import PaymentService from '@/service/payment.service';
import { namespace } from 'vuex-class';
import UserMyPageService from '@/service/userMyPage.service';
import PlanChangeFail from '@/v2/components/payment/plan-change-fail/plan-change-fail.vue';
import ConfirmChangePlan from '@/v2/components/payment/confirm-change-plan/confirm-change-plan.vue';
import PlanChangeComplete from '@/v2/components/payment/plan-change-complete/plan-change-complete.vue';
import { TYPE_CHANGE_PLAN } from '@/constants';

const appStoreState = namespace('appStore');

@Component({
  computed: {
    TYPE_CHANGE_PLAN() {
      return TYPE_CHANGE_PLAN;
    },
  },
  methods: { convertDateToCustomFormat },
  components: {
    'confirm-change-plan': ConfirmChangePlan,
    'plan-change-complete': PlanChangeComplete,
    'plan-change-fail': PlanChangeFail,
  },
})
export default class PaymentHistory extends Vue {
  @Inject('userMyPageService')
  private userMyPageService: () => UserMyPageService;

  @Inject('paymentService')
  private paymentService: () => PaymentService;

  @appStoreState.Mutation
  public setIsShowPopupCancelPayment!: (payload: any) => void;

  created() {
    this.getPaymentHistory();
  }

  paymentHistories = [];
  nextPlan = new UserPlan();
  currentPlan = new UserPlan();
  openConfirmChangePlan = false;
  openPlanChangeComplete = false;
  openPlanChangeFail = false;
  errorCode = '';
  waitingChangePlanApi = false;
  currentPlanTitle = '';

  roueToMyPage() {
    this.$router.push('/my-page');
  }

  getPaymentHistory() {
    this.paymentHistories = [];
    this.paymentService()
      .getPaidHistory()
      .then(res => {
        if (res.data && res.data.length > 0) {
          this.paymentHistories = res.data;
          this.nextPlan = this.paymentHistories.find(item => item.isNextPlan);
          if (this.nextPlan) {
            this.nextPlan.planView = this.nextPlan.productType == 100 ? 'Pro' : 'Ultra';
            this.nextPlan.period = this.getPeriod(this.nextPlan.startDate, this.nextPlan.endDate);
          }
          this.currentPlan = this.paymentHistories.find(item => item.isCurrentPlan);
        }
      });
  }

  getPeriod(startDate, endDate) {
    if (startDate && endDate) {
      const start = convertDateToCustomFormat(new Date(startDate), 'yyyy.MM.dd');
      const end = convertDateToCustomFormat(new Date(endDate), 'yyyy.MM.dd');
      return start + ' ~ ' + end;
    }
    return '';
  }

  async cancelPayment() {
    if (this.waitingChangePlanApi) {
      return;
    }

    this.waitingChangePlanApi = true;

    try {
      const res = await this.userMyPageService().callAPICancelPayment(this.nextPlan.paidplanId, this.nextPlan.stripeSubscriptionId);

      if (res.status === 200) {
        this.currentPlanTitle = this.nextPlan.productType == 100 ? 'Pro' : 'Ultra';
        this.openPlanChangeComplete = true;
        this.openConfirmChangePlan = false;
        this.getPaymentHistory();
      } else {
        this.errorCode = '00101';
        this.openPlanChangeFail = true;
        this.openConfirmChangePlan = false;
      }
    } catch (err) {
      const responseData = err?.response?.data;
      const matchedCode = typeof responseData === 'string' ? responseData.match(/ERROR_CODE:\s*(\d+)/) : null;
      this.errorCode = matchedCode ? matchedCode[1] : '00101';
      this.openPlanChangeFail = true;
      this.openConfirmChangePlan = false;
    } finally {
      this.waitingChangePlanApi = false;
    }
  }

  handleOpenConfirmModal() {
    this.openConfirmChangePlan = true;
    this.currentPlanTitle = this.nextPlan.productType == 100 ? 'Pro' : 'Ultra';
  }

  getCurrencyUnit(currency: string) {
    return currency == 'KRW' ? '₩' : '$';
  }
}
